
export const DateFromBackendUtc = (value: string | null | undefined): Date | undefined => {
    return !!value 
        ? new Date(Date.parse(value.split('.')[0]+'.000Z'))
        : undefined;
}
